module.exports = __webpack_public_path__ + "static/media/doctor-12.83b5495c.jpg";